<template>
  <div>
    <!-- Your payment form here -->
    <form @submit.prevent="handlePayment">
      <!-- Payment inputs, e.g., card number, expiration date, CVC, etc. -->
      <input type="text" v-model="cardNumber" placeholder="Card Number">
      <!-- Other payment-related input fields -->

      <button type="submit">Pay</button>
    </form>
  </div>
</template>

<script>
import { ref } from 'vue';
import { loadStripe } from '@stripe/stripe-js';

export default {
  setup() {

    const stripePromise = loadStripe('pk_test_51NKaTUAFOgKCQTYcn4eJ0kHxhrs2WCKy3exYXJrxvZBHQAOf338QEjP9LeMDk9XvhsXC1u9JC1LWR7bAmHNx2ysV00kYbolH19');


    const cardNumber = ref('');

    const handlePayment = async () => {
      const stripe = await stripePromise;
      const { error } = await stripe.confirmCardPayment('sk_test_51NKaTUAFOgKCQTYcJaD4Iciwflnj3XFK5cN4fyMOoQZBhzsMulEdnDrc31xKGEXTZWUknzFgVQzCXtcTgNV3FUBZ00g3lJxHAV', {
        payment_method: {
          card: {
            number: cardNumber.value,
            // Other card details (e.g., exp_month, exp_year, cvc)
          },
        },
      });

      if (error) {
        console.error('Error during payment:', error);
        // Handle the error gracefully in your application
      } else {
        // Payment succeeded
        console.log('Payment succeeded!');
      }
    };

    return {
      cardNumber,
      handlePayment,
    };
  },
};
</script>